module.exports = __webpack_public_path__ + "static/img/w02.e74e028.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/akvarium-uveg/w02.jpg
// module id = 536
// module chunks = 0